import React from "react";
import Card from "react-bootstrap/Card";
import { Row, Col } from "react-bootstrap";

function DeepReflectionCard(props) {
    return (
        <Card className="quote-card-view">
            <Card.Body>
                <h4 className="purple" style={{ marginBottom: "20px" }}>
                    {props.title}
                </h4>        <div style={{ textAlign: "justify", lineHeight: "1.6", marginBottom: "20px" }}>
                    {props.content.split('\n\n').map((paragraph, index) => (
                        <p key={index} style={{ marginBottom: "15px" }}>
                            {paragraph.split('\n').map((line, lineIndex) => (
                                <span key={lineIndex}>
                                    {line}
                                    {lineIndex < paragraph.split('\n').length - 1 && <br />}
                                </span>
                            ))}
                        </p>
                    ))}
                </div>
                {props.category && (
                    <footer className="blockquote-footer" style={{ marginTop: "25px", paddingTop: "10px", borderTop: "1px solid rgba(155, 126, 172, 0.3)" }}>
                        <cite title="Source Title">{props.category}</cite>
                    </footer>
                )}
            </Card.Body>
        </Card>
    );
}

function DeepReflections() {
    const deepThoughts = require("../../Assets/deep-thoughts.json");

    return (
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
            {deepThoughts.map((thought, index) => (
                <Col md={6} className="project-card" key={index} style={{ marginBottom: "30px" }}>
                    <div id={`deep-reflections-item-${index}`}>
                        <DeepReflectionCard
                            title={thought.title}
                            content={thought.content}
                            category={thought.category}
                        />
                    </div>
                </Col>
            ))}
        </Row>
    );
}

export default DeepReflections;
